import { mobile } from "components/templates/Breakpoints";
import { FC } from "react";
import styled from "styled-components";

interface CustomBulletProps {
  alt?: string;
  src?: string;
  translateY?: string;
}

export const CustomBullet: FC<CustomBulletProps> = ({
  alt = "Green check",
  src = "/static/img/get-a-quote/bullets/green-check.svg",
  translateY = "0",
}) => {
  return <CustomBulletImage $translateY={translateY} src={src} alt={alt} />;
};

const CustomBulletImage = styled.img<{ $translateY: string }>`
  width: 1.5rem;
  height: 1.5rem;
  transform: translateY(${(p) => p.$translateY || "1rem"});

  ${mobile} {
    transform: translateY(0.2rem);
  }
`;
